(function($) {
    "use strict";

    FG.AjaxJob = function(url)
    {
        var Ajax = new FG.Ajax(url),
            /**
             * Initializes the promise object to be called when the job is complete
             */
            deferred = $.Deferred(),
            /**
             * Sets the request payload to be sent along with the Ajax request
             * @type {object|null}
             */
            requestData = null,
            /**
             * The callbacks to be executed upon completion of a successful request
             * @type {function[]}
             */
            successCallbacks = [],
            /**
             * The callbacks to be executed upon completion of a failed request
             * @type {function[]}
             */
            failureCallbacks = [],
            /**
             * The callbacks to be executed upon completion of a successful or failed request
             * @type {function[]}
             */
            alwaysCallbacks = [],
            /**
             * The callback to be executed when having to wait before running a job check
             * @type {null|function}
             */
            waitTimeCallback = null,
            /**
             * The selector for the element so Ajax errors can be placed in
             * @type {null|string}
             */
            messageDiv = null,
            /**
             * The Ladda button object that we'll be updating while we wait for our job to finish
             * @type {null|Ladda}
             */
            laddaButton = null,
            /**
             * Should the email sent message be shown
             * @type {boolean}
             */
            showEmailSentMessage = false,
            /**
             * The max percentage to move the progress bar towards while waiting
             * @type {number}
             */
            maxProgress = 1,
            /**
             * How far the progress bar on the Ladda button has already gone
             * @type {number}
             */
            totalProgress = 0,
            /**
             * Number of job checks executed for the Ladda button calculations
             * @type {number}
             */
            jobCheckCount = 0,
            /**
             * The Ajax callback to be used to check whether our promise is resolved, failed or still waiting
             * @param FGResponse
             */
            ajaxCallback = function(FGResponse) {

                //If the standby code throws this exception, regex out the -buy from URL and redirect
                if(typeof FGResponse == "undefined" || FGResponse.errorType == 'StandbyUnauthenticatedException' || FGResponse.errorType == 'StandbyFailedAuthenticationException'){
                        window.location.reload();
                        return false;
                }


                // The job has not finished yet, so we need to wait and execute a job check
                if(FGResponse.isJob == true){

                    //Do we have cart expiry set?
                    if(typeof FGResponse.cartExpiry != 'undefined' && FGResponse.cartExpiry != null){
                        FG.CartTimer.setCartExpiry(FGResponse.cartExpiry);
                        FG.CartTimer.init();
                    }

                    //Set the response on base.
                    if (FG.Base.setJobResponse(FGResponse)) {

                        // Check for any waitTime callbacks and execute them
                        if (waitTimeCallback !== null) {
                            waitTimeCallback(FGResponse.wait);
                        }

                        // Check if any Ladda buttons are attached and run the progress bar
                        if (laddaButton !== null) {
                            setLaddaButtonProgress(FGResponse.wait);
                        }

                        // Initiate the next job/check to see if the job has finished
                        setTimeout(function () {

                            var Ajax = new FG.Ajax('job/check');

                            Ajax.setMessageDiv(messageDiv);
                            Ajax.setShowEmailSentMessage(showEmailSentMessage);
                            Ajax.setSuccessCallback(ajaxCallback);

                            Ajax.setFailureCallback(ajaxCallback);

                            Ajax.send();

                        }, FGResponse.wait);
                    }

                } else {
                    // The job has finished so we need to check whether there was an error not
                    if(FGResponse.error == 0) {
                        // Job finished successfully, resolve the promise and run all success and always callbacks
                        deferred.resolve(FGResponse);
                    } else {
                        // Job failed, reject the promise and run all failed and always callbacks
                        deferred.reject(FGResponse);
                    }

                    FG.AjaxJob.inJob = false;
                }
            },
            /**
             *  Rebuild the ajax call and promise
             */
            rebuilldAjaxJob = function() {
                var callback = null;
                Ajax = new FG.Ajax(url);
                Ajax.setMessageDiv(messageDiv);
                Ajax.setRequestData(requestData);
                Ajax.setSuccessCallback(ajaxCallback);
                Ajax.setFailureCallback(ajaxCallback);

                deferred = $.Deferred();

                for (callback in successCallbacks) {
                    deferred.promise().done(callback);
                }

                for (callback in failureCallbacks) {
                    deferred.promise().fail(callback);
                }

                for (callback in alwaysCallbacks) {
                    deferred.promise().always(callback);
                }
            },
            /**
             * Emulate progress on the ladda progress bar
             * @param waitTime
             */
            setLaddaButtonProgress = function (waitTime) {
                var maxCount = 5 + (10 * jobCheckCount),
                    count = 0,
                    incrementProgress = function() {
                        totalProgress += (maxProgress / maxCount);

                        laddaButton.setProgress(totalProgress);

                        if (count < maxCount) {
                            setTimeout(incrementProgress, waitTime / maxCount);
                        }

                        count++;
                    };

                maxProgress *= 0.45;

                jobCheckCount++;

                setTimeout(incrementProgress, waitTime / maxCount);
            };

        Ajax.setSuccessCallback(ajaxCallback);
        Ajax.setFailureCallback(ajaxCallback);

        return {
            /**
             * Returns the promise object for this object,
             * NEVER RETURN THE DEFERRED OBJECT
             * @returns {*}
             */
            promise : function()
            {
                return deferred.promise();
            },
            /**
             * Add a callback to the success callstack
             * @param callback
             */
            setSuccessCallback : function(callback)
            {
                successCallbacks.push(callback);
                this.promise().done(callback);
            },
            /**
             * Add a callback to the failed callstack
             * @param callback
             */
            setFailureCallback : function(callback)
            {
                failureCallbacks.push(callback);
                this.promise().fail(callback);
            },
            /**
             * Add a callback to the always callstack
             * @param callback
             */
            setAlwaysCallback : function(callback)
            {
                alwaysCallbacks.push(callback);
                this.promise().always(callback);
            },
            /**
             * Set the request data for the ajax request
             * @param payload
             */
            setRequestData : function(payload)
            {
                requestData = payload;
                Ajax.setRequestData(payload);
            },
            /**
             * Set the dom element where status messages are placed
             * @param selector
             */
            setMessageDiv : function(selector)
            {
                messageDiv = selector;
                Ajax.setMessageDiv(selector);
            },
            /**
             * Setter to hide/show the email sent message div
             * @param showMessage
             */
            setShowEmailSentMessage : function(showMessage){
                showEmailSentMessage = showMessage;
                Ajax.setShowEmailSentMessage(showMessage);
            },
            /**
             * Set the waitTimeCallback to be executed during job checks
             * @param callback
             */
            setWaitTimeCallback : function(callback)
            {
                waitTimeCallback = callback;
            },
            /**
             * Returns the Ajax object
             * @returns {window.FG.Ajax}
             */
            getAjax : function()
            {
                return Ajax;
            },
            /**
             * Executes the Ajax call
             */
            send : function()
            {
                FG.AjaxJob.inJob = true;
                Ajax.send();
            },
            /**
             * Rebuild a completed promise and evaluate the given results
             * @param FGResponse
             */
            revaluateResponse : function(FGResponse)
            {
                rebuilldAjaxJob();
                ajaxCallback(FGResponse);
            },
            /**
             * Executes an error message
             * @param message
             */
            error : function(message) {
                Ajax.error(message);
            },
            /**
             * Sets the LaddaButton value to be updated with job checks
             * @param newLaddaButton
             */
            setLaddaButton : function(newLaddaButton)
            {
                laddaButton = newLaddaButton;
            }
        };
    };
})(jQuery);
